"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _storage = require("@/api/storage");
var _auth = require("@/utils/auth");
var _config = require("@/api/config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      uploadPath: _storage.uploadPath,
      listLoading: false,
      // 表格加载
      dialogVisible: false,
      // 弹窗
      title: '新建免费试用',
      // 弹窗标题
      id: null,
      status: null,
      form: {
        name: '',
        startTime: '',
        endTime: '',
        duration: undefined,
        isOverseas: undefined,
        time: []
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        duration: [{
          required: true,
          message: '请输入天数',
          trigger: 'blur'
        }],
        isOverseas: [{
          required: true,
          message: '请选择站点',
          trigger: 'change'
        }]
      },
      options: [{
        value: 0,
        label: '国内站'
      }, {
        value: 1,
        label: '海外站'
      }, {
        value: 2,
        label: '国内站/海外站'
      }],
      list: [],
      // 表格数据
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    handleOk: function handleOk() {
      var _this = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.form), {}, {
            id: _this.id
          });
          delete params.time;
          console.log('params', params);
          (0, _config.freeEdit)(params).then(function (res) {
            console.log('res111', res);
            if (res.data.errno == 0) {
              _this.dialogVisible = false;
              _this.getList();
              if (!_this.id) return _this.$message.success('添加成功');
              _this.$message.success('编辑成功');
            }
          });
        }
      });
    },
    handleTime: function handleTime(val) {
      console.log('val', val);
      this.form.time = val;
      this.form.startTime = val[0];
      this.form.endTime = val[1];
    },
    handle: function handle(row, type) {
      this.dialogVisible = true;
      row ? this.id = row.id : this.id = null;
      // 如果存在id，说明是编辑，否则是添加
      if (this.id) {
        // 查看
        if (type === 'check') {
          this.status = 'check';
          this.title = '查看免费试用活动';
          this.getDetail(this.id);
        }
        // 编辑
        if (type === 'edit') {
          this.status = 'edit';
          this.title = '编辑免费试用活动';
          this.getDetail(this.id);
        }
      } else {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
        this.status = null;
        this.title = '新建免费试用活动';
        this.form = {
          name: '',
          startTime: '',
          endTime: '',
          duration: undefined,
          isOverseas: undefined,
          time: []
        };
      }
    },
    // 删除
    handleEelete: function handleEelete(id) {
      var _this2 = this;
      (0, _config.freeDelete)({
        id: id
      }).then(function (res) {
        _this2.$message.success('删除成功');
        _this2.getList();
      });
    },
    // 获取详情
    getDetail: function getDetail(id) {
      var _this3 = this;
      (0, _config.freeDetail)({
        id: id
      }).then(function (res) {
        console.log('resDetail', res);
        if (res.data.errno == 0) {
          _this3.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.form), res.data.data);
          _this3.form.time = [_this3.form.startTime, _this3.form.endTime];
        }
      });
    },
    getList: function getList() {
      var _this4 = this;
      (0, _config.freeList)({}).then(function (res) {
        console.log('resList', res);
        if (res.data.errno == 0) {
          _this4.list = res.data.data;
          _this4.list.forEach(function (item) {
            item.startTime = item.startTime.split(' ')[0];
            item.endTime = item.endTime.split(' ')[0];
          });
        }
      });
    },
    onStatus: function onStatus(status) {
      var newStatus = '';
      switch (status) {
        case 0:
          newStatus = '未开始';
          break;
        case 1:
          newStatus = '进行中';
          break;
        case 2:
          newStatus = '已结束';
          break;
        default:
          break;
      }
      return newStatus;
    },
    onOverseas: function onOverseas(status) {
      var value = '';
      switch (status) {
        case 0:
          value = '国内站';
          break;
        case 1:
          value = '海外站';
          break;
        case 2:
          value = '国内站/海外站';
          break;
        default:
          break;
      }
      return value;
    }
  }
};